import React from 'react';
import { Link, Redirect } from "react-router-dom";
import {
	Card,
	Form,
	Input,
	Button,
	Select,
	message,
	Typography,
} from 'antd';
import {
	SaveOutlined,
	CloseCircleOutlined,
	SettingOutlined,
	PrinterOutlined,
	EditOutlined,
	PlusCircleOutlined,
	ArrowLeftOutlined,
	IdcardOutlined,
} from '@ant-design/icons';
import moment from 'moment';

import Config from '../../Config';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
	extractResult,
} from "../../store/actions";
import {Helmet} from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title: 'Form Printer',
	apiUrl: {
		preview: "addons/api/printer/",
	},
	pageUrl: {
		data: '/admin/pengaturan/printer'
	},
	breadCrumb: [
		<span><SettingOutlined /> Pengaturan</span>,
		'Printer',
		'Form',
	]

}

const config = new Config();

const FIELD_STYLE = {
	borderRadius: 8,
	height: 40,
};

class FormPengaturanPrinter extends React.Component {
	formRef = React.createRef();

	constructor(props){
		super(props);

		this.state = {
			errComponent: false,
			errTitle: '',
			errMsg: '',
			loadingButton: false,

			aksi: 'tambah',
			method: 'post',
			idLama: '',

			listPegawai: [],
			loadingPegawai: false,

			listPegawai2: [],
			loadingPegawai2: false,

			isMobile: window.innerWidth <= 768,
		}
	}

	UNSAFE_componentWillMount(){
		this.props.initHandler();
	}

	componentWillUnmount(){
		window.removeEventListener('resize', this._handleResize);
	}

	componentDidMount(){
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);

		if(this.props.match.params.id != undefined){
			this.preview(this.props.match.params.id);
		}
	}

	async preview(id) {
		message.loading({ content: 'Menampilkan data sebelumnya...', duration: 0, key: 'toast' });

		this.props.ajaxViewHandler('get', configClass.apiUrl.preview+id)
		.then((action) =>{
			const { isSuccess, responseMsg: data } = extractResult(action);
			if(isSuccess){
				this.formRef.current.setFieldsValue(data);
				for ( var key in data ) {
				    const dateRegex = /^[0-9]{2}\-[0-9]{2}\-[0-9]{4}$/;
				    const dateTimeRegex = /^[0-9]{2}\-[0-9]{2}\-[0-9]{4} [0-9]{2}\:[0-9]{2}\:[0-9]{2}$/;
				    if(dateRegex.test(data[key])){//jika format tanggal			    	
				    	this.formRef.current.setFieldsValue({
				    		[key+'_picker']: moment(data[key], 'DD-MM-YYYY'),
							//[key]: moment(data[key], 'DD-MM-YYYY')
						});
				    }else if(dateTimeRegex.test(data[key])){//jika format tanggal dan jam	    	
				    	this.formRef.current.setFieldsValue({
				    		[key+'_picker']: moment(data[key], 'DD-MM-YYYY HH:mm:ss'),
						});
				    }/*else{
				    	this.formRef.current.setFieldsValue({
				    		[key]: data[key]
				    	});
				    }*/
				    
	        	}
	        	message.destroy();
	        	this.setState({
	        		aksi: 'edit',
	        		method: 'put',
	        		idLama: id+'/'
	        	});
	        }else{
	        	const errTitle = 'error preview data lama';
	        	this.setState({
	        		errTitle: errTitle,
	        		errMsg: data
	        	});
	        	message.error({ content: errTitle, duration: 2, key: 'toast' });
	        }
		}).catch((response) => {
			console.log('gagal_get_preview', response);
			message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
		});
	}

	handleSubmit = (values) =>{
		var datas = values;
		this.postData(datas);
		// console.log('values', values);
	}

	async postData(datas) {
		message.loading({ content: 'Memproses...', key: 'toast' });

		this.props.ajaxHandler(this.state.method, configClass.apiUrl.preview+this.state.idLama, datas, false, true)
		.then((action) =>{
			this.setState({
				loadingButton: false
			});
			const { isSuccess, responseMsg } = extractResult(action);
			if(isSuccess){
				message.success({ content: 'berhasil menyimpan data', duration: 2, key: 'toast' });
			}else{
				const errTitle = 'gagal menyimpan data'
				message.error({ content: errTitle, duration: 2, key: 'toast' });
				this.setState({
					errTitle: errTitle,
					errMsg: responseMsg
				});
			}
		}).catch((response) => {
			console.log('gagal_post', response);
			this.setState({
				loadingButton: false
			});
			message.error({ content: 'kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
		});
	}

	render() {
		if(this.props.isRedirect){
			return <Redirect to={configClass.pageUrl.data} />
		}

		const { isMobile, aksi, errMsg, errTitle, loadingButton, errComponent } = this.state;
		const isEdit = aksi === 'edit';
		const pageTitle = isEdit ? 'Edit Printer' : 'Tambah Printer';

		return(
			<div>
				<Helmet>
					<title>{pageTitle+" | "+config.get_site_info().name}</title>
					<style>{`
						.form-printer-wrap .ant-form-item-label > label {
							font-weight: 600;
							color: #374151;
							font-size: 13px;
						}
						.form-printer-wrap .ant-input,
						.form-printer-wrap .ant-select-selector {
							border-radius: 8px !important;
						}
						.form-printer-wrap .ant-input:focus,
						.form-printer-wrap .ant-select-focused .ant-select-selector {
							border-color: #1e4d8a !important;
							box-shadow: 0 0 0 2px rgba(30,77,138,0.1) !important;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Form
					layout="vertical"
					name="fdata"
					onFinish={this.handleSubmit}
					ref={this.formRef}
					className="form-printer-wrap"
				>
					<Card
						style={{
							borderRadius: 14,
							boxShadow: '0 4px 20px rgba(0,0,0,0.07)',
							overflow: 'hidden',
							maxWidth: 640,
						}}
						bodyStyle={{ padding: 0 }}
					>
						{/* Header */}
						<div style={{
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							padding: '20px 24px',
							display: 'flex',
							alignItems: 'center',
							gap: 16,
						}}>
							<div style={{
								width: 52,
								height: 52,
								borderRadius: 14,
								background: 'rgba(255,255,255,0.15)',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								flexShrink: 0,
							}}>
								{isEdit
									? <EditOutlined style={{ color: '#fff', fontSize: 24 }} />
									: <PlusCircleOutlined style={{ color: '#fff', fontSize: 24 }} />
								}
							</div>
							<div style={{ flex: 1, minWidth: 0 }}>
								<div style={{ color: '#fff', fontWeight: 700, fontSize: 18, lineHeight: 1.3 }}>
									{pageTitle}
								</div>
								<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13, marginTop: 3 }}>
									{isEdit ? 'Ubah informasi printer' : 'Isi formulir untuk menambah printer baru'}
								</div>
							</div>
							<Link to={configClass.pageUrl.data}>
								<Button
									icon={<ArrowLeftOutlined />}
									style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', borderRadius: 8, flexShrink: 0 }}
								>
									{!isMobile && 'Kembali'}
								</Button>
							</Link>
						</div>

						{/* Section header */}
						<div style={{
							padding: '14px 24px',
							background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
							borderBottom: '1.5px solid #d0dff5',
							display: 'flex',
							alignItems: 'center',
							gap: 10,
						}}>
							<PrinterOutlined style={{ color: '#1e4d8a', fontSize: 16 }} />
							<Text strong style={{ fontSize: 14, color: '#0f2847' }}>
								Informasi Printer
							</Text>
						</div>

						{/* Form fields */}
						<div style={{ padding: '24px 28px' }}>
							<Form.Item
								label={<span><PrinterOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Tipe Dokumen</span>}
								name="tipe"
								rules={[{ required: true, message: 'Tipe dokumen harus diisi' }]}
							>
								<Select
									autoFocus
									showSearch
									placeholder="Pilih tipe dokumen"
									optionFilterProp="children"
									allowClear
									style={{ width: '100%' }}
								>
									<Select.Option value={1}>Kutipan</Select.Option>
									<Select.Option value={2}>Notice</Select.Option>
								</Select>
							</Form.Item>

							<Form.Item
								label={<span><PrinterOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Nama Printer</span>}
								name="nama"
								rules={[{ required: true, message: 'Nama printer harus diisi' }]}
							>
								<Input placeholder="cth: Epson LQ-310" style={FIELD_STYLE} />
							</Form.Item>

							<Form.Item
								label={<span><IdcardOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Serial</span>}
								name="serial"
								rules={[{ required: true, message: 'Serial printer harus diisi' }]}
								style={{ marginBottom: 0 }}
							>
								<Input placeholder="Serial printer..." style={FIELD_STYLE} />
							</Form.Item>
						</div>

						{/* Footer tombol */}
						<div style={{
							padding: '16px 28px',
							display: 'flex',
							gap: 10,
							justifyContent: isMobile ? 'stretch' : 'flex-end',
							flexDirection: isMobile ? 'column' : 'row',
							background: '#fafafa',
							borderTop: '1px solid #f0f0f0',
						}}>
							<Link to={configClass.pageUrl.data} style={isMobile ? { display: 'block' } : {}}>
								<Button
									icon={<CloseCircleOutlined />}
									size="large"
									disabled={loadingButton}
									style={{ borderRadius: 10, ...(isMobile ? { width: '100%' } : {}) }}
								>
									Batal
								</Button>
							</Link>
							<Button
								type="primary"
								htmlType="submit"
								icon={<SaveOutlined />}
								size="large"
								loading={loadingButton}
								disabled={errComponent}
								style={{
									borderRadius: 10,
									background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
									border: 'none',
									fontWeight: 600,
									...(isMobile ? { width: '100%' } : {}),
								}}
							>
								{isEdit ? 'Simpan Perubahan' : 'Tambah Printer'}
							</Button>
						</div>
					</Card>
				</Form>
			</div>
		);
	}
}

const mapStateToProps = function(state) {
	return state.configReducers
}

export default connect(
		mapStateToProps,
		{
			initHandler,
			setConfig,
			ajaxViewHandler,
			ajaxHandler
		}
	)(FormPengaturanPrinter);